import { render, staticRenderFns } from "./OnboardingTypeform.vue?vue&type=template&id=7821f638&"
import script from "./OnboardingTypeform.vue?vue&type=script&lang=js&"
export * from "./OnboardingTypeform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports